import React, { useEffect, useMemo, useState } from 'react';
import _ from 'lodash';
import propTypes from 'prop-types';
import { useField, useFormikContext } from 'formik';
import ExpressionsList from '../../expressions/ExpressionsList';
import StepBackBone, { useStepperController } from './step-backbone';
import { createFilterOptions, Stack } from '@mui/material';
import { SensorsChart } from '../../../../../../devices';
import { useOnlineDeviceStream } from '../../../../live/online-device-provider';
import { useSensorsDatasetFromField } from './choose-inputs';
import { evaluate } from 'mathjs';
import { Autocomplete } from 'formik-mui';

const expressionAlgorithm = (expression) => {
  return (scope, value, history) => {
    try {
      return evaluate(expression, scope);
    } catch (e) {
      return null;
    }
  }
}

export const useExpressionsDatasetFromField = (namespace) => {
  const [{ value }, meta] = useField(namespace);
  const [data, setData] = useState([]);

  useEffect(() => {
    const data = [];
    _.each(value, (expression) => {
      data.push({
        noBackground: true,
        __name: expression.n,
        __key: expression.n,
        __compute: expressionAlgorithm(expression.e),
      });
    });
    setData(data);
  }, [value, setData]);

  return { data, value };
}

export default function WriteExpressions({ namespace }) {

  const { setNextButtonDisabled } = useStepperController();
  const [field, meta] = useField(namespace + '.e');
  const { setFieldValue } = useFormikContext();

  const { dataset, emitter } = useOnlineDeviceStream();
  const { data: sensors } = useSensorsDatasetFromField(namespace + '.i', dataset);
  const { data: expressions } = useExpressionsDatasetFromField(namespace + '.e');

  // Auto-fill first expression with sum of selected sensors if empty
  useEffect(() => {
    if (field.value?.[0]?.e === '' && sensors.length > 0) {
      const sum = sensors.map(s => s.__key).join(' + ');
      setFieldValue(namespace + '.e[0].e', sum);
    }
  }, [sensors]);

  const data = useMemo(() => [...sensors, ...expressions], [sensors, expressions]);

  useEffect(() => {
    setNextButtonDisabled(meta.error);
  }, [meta.error, setNextButtonDisabled]);

  return (
    <StepBackBone>
      <Stack spacing={2}>
        <SensorsChart defaultStarted={true} datasets={data} emitter={emitter} height='400px' />
        <ExpressionsList namespace={namespace + '.e'} sensors={sensors} simplified />
      </Stack>
    </StepBackBone>
  );
}

WriteExpressions.propTypes = {
  namespace: propTypes.string,
  device: propTypes.object,
}